import React, { useEffect } from 'react';
import { useParams, Routes, Route, Navigate } from 'react-router-dom';
import './RecipeBook.css';

import RecipeList from './RecipeList';
import RecipeDetails from './RecipeDetails';
import { demoRecipes } from './recipes';
import { getUITranslation } from './utils';
import { LANGUAGES } from './constants';

function RecipeBookDetailsWrapper() {
    const { lang, id } = useParams();
    const recipe = demoRecipes.find(r => r.id === id);
    if (!recipe) return <div style={{ padding: 40 }}>{getUITranslation('recipeNotFound', lang)}</div>;
    return <RecipeDetails recipe={recipe} lang={lang} />;
}

function RecipeListWrapper() {
    const { lang } = useParams();
    return <RecipeList recipes={demoRecipes} lang={lang} />;
}

const RecipeBook = () => {
    const { lang: urlLang } = useParams();
    
    // Validate language parameter
    const validLanguages = LANGUAGES.map(l => l.code);
    const isValidLang = urlLang && validLanguages.includes(urlLang);
    
    useEffect(() => {
        const prevHtml = document.documentElement.style.background;
        const prevHtmlAttachment = document.documentElement.style.backgroundAttachment;
        const prevHtmlMinHeight = document.documentElement.style.minHeight;
        const prevBody = document.body.style.background;
        const prevBodyAttachment = document.body.style.backgroundAttachment;
        const prevBodyMinHeight = document.body.style.minHeight;
        
        const gradient = 'linear-gradient(120deg, #f8f6f1 0%, #f3e9d2 100%)';
        
        document.documentElement.style.background = gradient;
        document.documentElement.style.backgroundAttachment = 'fixed';
        document.documentElement.style.minHeight = '100vh';
        document.body.style.background = gradient;
        document.body.style.backgroundAttachment = 'fixed';
        document.body.style.minHeight = '100vh';
        
        return () => {
            document.documentElement.style.background = prevHtml || '';
            document.documentElement.style.backgroundAttachment = prevHtmlAttachment || '';
            document.documentElement.style.minHeight = prevHtmlMinHeight || '';
            document.body.style.background = prevBody || '';
            document.body.style.backgroundAttachment = prevBodyAttachment || '';
            document.body.style.minHeight = prevBodyMinHeight || '';
        };
    }, []);
    
    return (
        <div className="recipebook-root">
            <Routes>
                {/* Redirect root to default language */}
                <Route path="/" element={<Navigate to="/recipe-book/en" replace />} />
                
                {/* Redirect invalid languages to English */}
                {!isValidLang && urlLang && (
                    <Route path="/*" element={<Navigate to="/recipe-book/en" replace />} />
                )}
                
                {/* Recipe list by language */}
                <Route path="/:lang" element={<RecipeListWrapper />} />
                
                {/* Recipe details by language and ID */}
                <Route path="/:lang/:id" element={<RecipeBookDetailsWrapper />} />
            </Routes>
        </div>
    );
};

export default RecipeBook; 